import { render, staticRenderFns } from "./PassageSearchResultDetail.vue?vue&type=template&id=55842a3c&scoped=true&"
import script from "./PassageSearchResultDetail.vue?vue&type=script&lang=js&"
export * from "./PassageSearchResultDetail.vue?vue&type=script&lang=js&"
import style0 from "./PassageSearchResultDetail.vue?vue&type=style&index=0&id=55842a3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55842a3c",
  null
  
)

component.options.__file = "PassageSearchResultDetail.vue"
export default component.exports